import {
  Directive,
  Input,
  HostListener,
  ElementRef,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { NgControl, ValidationErrors } from "@angular/forms";
import { Subscription } from "rxjs";
import { ValidationMsgService } from "../validation-message.service";

@Directive({
  selector: "[crmFormValidator]",
})
export class FormControlValidationMsgDirective implements OnInit, OnDestroy {
  @Input() inputLabelName: string;

  errorSpanId: string = "";
  statusChangeSubscription: Subscription;

  constructor(
    private elRef: ElementRef,
    private control: NgControl,
    private validationMsgService: ValidationMsgService
  ) {}

  ngOnInit(): void {
    this.errorSpanId =
      (this.control.name || "control") +
      "-" +
      new Date().getTime() +
      "-error-msg";

    // Fallback label if not provided
    if (!this.inputLabelName) {
      this.inputLabelName = "This field";
    }

    // Subscribe only if statusChanges exists
    if (this.control && this.control.statusChanges) {
      this.statusChangeSubscription = this.control.statusChanges.subscribe(
        (status) => {
          if (status === "INVALID") {
            this.showError();
          } else {
            this.removeError();
          }
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.statusChangeSubscription) {
      this.statusChangeSubscription.unsubscribe();
    }
  }

  @HostListener("blur")
  handleBlurEvent(): void {
    if (!this.control) {
      return;
    }

    if (this.control.invalid && (this.control.touched || this.control.dirty)) {
      this.showError();
    } else if (this.control.valid) {
      this.removeError();
    }
  }

  private showError(): void {
    const existingError = document.getElementById(this.errorSpanId);
    if (existingError) {
      return;
    }

    const valErrors: ValidationErrors = this.control.errors;

    const errorMsg = this.validationMsgService.getValidationMsg(
      valErrors,
      this.inputLabelName
    );

    const errSpan =
      '<span style="color:red;" id="' +
      this.errorSpanId +
      '">' +
      errorMsg +
      "</span>";

    this.elRef.nativeElement.parentElement.insertAdjacentHTML(
      "beforeend",
      errSpan
    );
  }

  private removeError(): void {
    const errorElement = document.getElementById(this.errorSpanId);
    if (errorElement) {
      errorElement.remove();
    }
  }
}
